import React from 'react';
import HeroSection from '../components/HeroSection';
import VisibilityProblem from '../components/VisibilityProblem';
import MoneyLeaks from '../components/MoneyLeaks';
import AIPositioning from '../components/AIPositioning';
import HowItWorks from '../components/HowItWorks';
import WhatWeDeliver from '../components/WhatWeDeliver';
import RightForYou from '../components/RightForYou';
import Realizations from '../components/Realizations';
import PrimaryCTA from '../components/PrimaryCTA';
import InsightsHub from '../components/InsightsHub';
import LeadForm from '../components/LeadForm';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <MoneyLeaks />
      <VisibilityProblem />
      <AIPositioning />
      <HowItWorks />
      <WhatWeDeliver />
      <RightForYou />
      <Realizations />
      <PrimaryCTA />
      <InsightsHub />
      <LeadForm />
    </>
  );
};

export default HomePage;
